import { PROCESS } from "../../data/content";
import { Reveal } from "../Reveal";

export default function Process() {
  return (
    <section id="process" className="relative bg-navy-800 py-24 sm:py-32 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-12">
        <Reveal>
          <p className="mb-4 text-[11px] uppercase tracking-[0.4em] text-gold">How we work</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-3xl font-heading text-4xl font-light leading-tight text-offwhite sm:text-5xl">
            A process-driven build, not an informal one.
          </h2>
        </Reveal>

        <div className="relative mt-20">
          {/* structural beam line */}
          <div className="absolute left-0 top-6 hidden h-px w-full bg-gold/20 md:block" />
          <div className="grid gap-12 md:grid-cols-5 md:gap-6">
            {PROCESS.map((p, i) => (
              <Reveal key={p.no} delay={i * 0.08}>
                <div data-cursor="hover" className="group relative">
                  <div className="mb-6 flex items-center gap-4 md:block">
                    <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-navy-800 font-heading text-lg text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-navy-900">
                      {p.no}
                    </span>
                  </div>
                  <h3 className="font-heading text-2xl font-light text-offwhite">{p.title}</h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-offwhite/55">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
